(function($) {
    'use strict';

    console.log('working');

    setTimeout(() => {

        if ($('.product-page').length > 0) {
            $('.afterpay-text2').text('payment plans available for orders ')
                //             if($('.swatch .soldout').length > 0) {
                //             	let sold_cont = '<strong class="sold-text">SOLD OUT in some sizes but you can find them at <a href="https://www.iheartraves.com/" target="_blank">iHeartRaves</a></strong>'
                //                 $('#product-description form').append(sold_cont)
                //             }
            if ($('.product-add .add').length > 0) {
                if ($('.product-add .add').attr('value') == 'Sold Out') {
                    $('.shopify-payment-button').hide()
                        //                    $('.product-add').append('<a href="#" id="BIS_trigger" class="button email-pop">EMAIL WHEN AVAILABLE</a>')
                }
            }

            //          $('.product .select .selector-wrapper select option').each(function(){
            //            if($(this).text() == 'XS') {
            //              $(this).text('EXTRA SMALL')
            //            } else if($(this).text() == 'S') {
            //              $(this).text('SMALL')
            //            } else if($(this).text() == 'M') {
            //              $(this).text('MEDIUM')
            //            } else if($(this).text() == 'L') {
            //              $(this).text('LARGE')
            //            } else if($(this).text() == 'XL') {
            //              $(this).text('EXTRA LARGE')
            //            } else if($(this).text() == '2XL') {
            //              $(this).text('2 EXTRA LARGE')
            //            }
            //          })

            setTimeout(() => {
                $('.product-add .shopify-payment-button__button').text('BUY NOW')
                if ($('.money').text() == 'Sold Out') {
                    $('.select').attr('style', 'display: none !important');
                    $('.add-qty').attr('style', 'display: none !important');
                }

            }, 1500);


            //             $('ul.tabs').each(function(){
            //               let active, content, links = $(this).find('.link-tab')
            //               active = null

            //   //             $('.det-tab').append($('.details-tab'))
            //               $('.sizes-tab').append($('.size-tab'))
            //               links.each(function () {
            //                   $($(this).attr('href')).hide()
            //               });
            //               $(this).find('.link-tab').click(function(e){
            //                 if($('.active').length > 0) {
            //                   active.removeClass('active')
            //                   content.hide()
            //                 }

            //                 active = $(this)
            //                 content = $($(this).attr('href'))
            //                 active.addClass('active')
            //                 content.show()
            //                 return false
            //               });
            //              });
            $('ul.tabs').each(function() {
                var active, content, links = $(this).find('.link-tab');
                active = links.first().addClass('active');

                $('.descrip-tab .tab-content').append($('.details-tab'))
                content = $(active.attr('href'));
                links.not(':first').each(function() {
                    $($(this).attr('href')).hide();
                });
                $(this).find('.link-tab').click(function(e) {
                    active.removeClass('active');
                    content.hide();
                    active = $(this);
                    content = $($(this).attr('href'));
                    active.addClass('active');
                    content.show();
                    return false;
                });
            });
        }
    }, 1500);


    $(document).ready(function($) {
        if ($('.cont1').length > 0) {
            $(".cont1").click(function() {
                var a = $('.cont1 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont1-2').hide();
                    $(".cont1 .show i").addClass("fa-plus");
                    $(".cont1 .show i").removeClass("fa-times");
                } else {
                    $('.cont1-2').show();
                    $(".cont1 .show i").removeClass("fa-plus");
                    $(".cont1 .show i").addClass("fa-times");
                }
            });
            $(".cont2").click(function() {
                var a = $('.cont2 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont2-2').hide();
                    $(".cont2 .show i").addClass("fa-plus");
                    $(".cont2 .show i").removeClass("fa-times");
                } else {

                    $('.cont2-2').show();
                    $(".cont2 .show i").removeClass("fa-plus");
                    $(".cont2 .show i").addClass("fa-times");
                }
            });
            $(".cont3").click(function() {
                var a = $('.cont3 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont3-2').hide();
                    $(".cont3 .show i").addClass("fa-plus");
                    $(".cont3 show i").removeClass("fa-times");
                } else {
                    $('.cont3-2').show();
                    $(".cont3 .show i").removeClass("fa-plus");
                    $(".cont3 .show i").addClass("fa-times");
                }
            });

            $(".cont4").click(function() {
                var a = $('.cont4 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont4-2').hide();
                    $(".cont4 .show i").addClass("fa-plus");
                    $(".cont4 .show i").removeClass("fa-times");
                } else {
                    $('.cont4-2').show();
                    $(".cont4 .show i").removeClass("fa-plus");
                    $(".cont4 .show i").addClass("fa-times");
                }
            });
            $(".cont5").click(function() {
                var a = $('.cont5 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont5-2').hide();
                    $(".cont5 .show i").addClass("fa-plus");
                    $(".cont5 .show i").removeClass("fa-times");
                } else {
                    $('.cont5-2').show();
                    $(".cont5 .show i").removeClass("fa-plus");
                    $(".cont5 .show i").addClass("fa-times");
                }
            });
            $(".cont6").click(function() {
                var a = $('.cont6 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont6-2').hide();
                    $(".cont6 .show i").addClass("fa-plus");
                    $(".cont6 .show i").removeClass("fa-times");
                } else {
                    $('.cont6-2').show();
                    $(".cont6 .show i").removeClass("fa-plus");
                    $(".cont6 .show i").addClass("fa-times");
                }
            });
            $(".cont7").click(function() {
                var a = $('.cont7 .show .fa-plus').length;
                if (a == 0) {
                    $('.cont7-2').hide();
                    $(".cont7 .show i").addClass("fa-plus");
                    $(".cont7 .show i").removeClass("fa-times");
                } else {
                    $('.cont7-2').show();
                    $(".cont7 .show i").removeClass("fa-plus");
                    $(".cont7 .show i").addClass("fa-times");
                }
            });
        }

        if ($('#shopify-section-1541446959656').length > 0) {
            var insta_btn = $(this).find('.rte a');
            $(insta_btn).attr('target', '_blank');
        }

        if ($('.newsletter').length > 0) {
            var news_btn = $(this).find('#footer-subscribe');
            $(news_btn).text('SUBMIT');
            $(news_btn).attr('value', 'SUBMIT');
        }
        if ($('.collection').length > 0) {
            $('.product-index').each(function() {
                var boxes = $(this).find('.box-ratio')
                var sizes = $(this).find('.product-info .size-swatch')
                var prod_info = $(this).find('.product-info')[0]

                let link_coll = $(this).find('.icn + a')[0]
                let sale_flag = $(this).find('.sale-item')[0]
                let so_flag = $(this).find('.so')[0]

                $(link_coll).mouseover(function() {
                    if ($(window).width() <= '1300') {
                        $(sale_flag).css({ 'right': '-29px', 'top': '-76px' })
                    } else if ($(window).width() <= '1600') {
                        $(sale_flag).css({ 'right': '-33px', 'top': '-76px' })
                    } else {
                        $(sale_flag).css({ 'right': '-44px', 'top': '-77px' })
                    }
                })

                $(link_coll).mouseout(function() {
                    $(sale_flag).css({ 'right': '0', 'top': '-27px' })
                })

                $(link_coll).mouseover(function() {
                    if ($(window).width() <= '1300') {
                        $(so_flag).css({ 'right': '-29px', 'top': '-85px' })
                    } else if ($(window).width() <= '1600') {
                        $(so_flag).css({ 'right': '-33px', 'top': '-85px' })
                    } else {
                        $(so_flag).css({ 'right': '-44px', 'top': '-85px' })
                    }
                })

                $(link_coll).mouseout(function() {
                    $(so_flag).css({ 'right': '0', 'top': '-27px' })
                })

                boxes = $(boxes)[0]
                sizes = $(sizes)[0]
                prod_info = $(prod_info).clone(true, true)

                $($(boxes)).append($(sizes))
                $($(boxes)).append($(prod_info))
            })
        }

        if ($('#shopify-section-1541446959656').length > 0) {
            $('body').toggleClass('home')
        }

        if ($('.newsletter').length > 0) {
            $('.newsletter #footer-EMAIL').attr('required', '');
        }
//         if ($(window).width() <= '989') {
//             //           $('.shifter-handle').on('click', function(e){
//             //             e.preventDefault()
//             //             e.stopPropagation()

//             //           	$('.shifter-navigation').css('opacity', 1)
//             //             $('.shifter-navigation').css('pointer-events', 'none')
//             //             $('.shifter-navigation').css('transform', 'translate3D(0, 0, 0)')
//             //             $('.shifter-navigation').css('transition', 'opacity 0.001s linear 0s, transform 0.2s ease')
//             //           })

//             if ($('.site-header__cart-toggle').length > 0) {
//                 $('.shifter-navigation #accordion').append($('.site-header__cart-toggle'))
//             }
//         }
        $('#footer li a').each(function() {
            if ($(this).text() == 'Rolita Rebel Community')
                $(this).attr('target', '_blank')
        });

    });
})(jQuery);